var exports = {
  "k": "xa15a2ab7--84f3bd--container",
  "K": "xa15a2ab7--84f3bd--icon",
};

module.exports = exports;
